export const cabRequestReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_CAB_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        cabs: null,
      };
    }
    case "GET_CAB_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        cabs: action.payload,
      };
    }
    case "GET_CAB_LIST_FAILED": {
      return {
        ...state,
        loading: true,
        cabs: action.payload,
      };
    }

    case "GET_CAB_REQUEST": {
      return {
        ...state,
        loading: true,
        cab: null,
      };
    }
    case "GET_CAB_SUCCESS": {
      return {
        ...state,
        loading: false,
        cab: action.payload,
      };
    }
    case "GET_CAB_FAILED": {
      return {
        ...state,
        loading: true,
        cab: action.payload,
      };
    }

    case "ADD_CAB_CATEGORY_REQUEST": {
      return {
        ...state,
        loading: true,
        cabs: null,
      };
    }
    case "ADD_CAB_CATEGORY_SUCCESS": {
      return {
        ...state,
        loading: false,
        cabs: action.payload,
      };
    }
    case "ADD_CAB_CATEGORY_FAILED": {
      return {
        ...state,
        loading: true,
        cabs: action.payload,
      };
    }
        // === GET CAB SERVICE PROVIDER LIST ===
    case "GET_CAB_SERVICE_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        cabServiceList: null,
      };
    case "GET_CAB_SERVICE_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        cabServiceList: action.payload,
      };
    case "GET_CAB_SERVICE_LIST_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // === ADD CAB SERVICE PROVIDER ===
    case "ADD_CAB_SERVICE_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "ADD_CAB_SERVICE_SUCCESS":
      return {
        ...state,
        loading: false,
        addCabServiceResponse: action.payload,
      };
    case "ADD_CAB_SERVICE_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
